module.exports = __webpack_public_path__ + "static/media/icons_Bilan Genou - reprise post-LCA + tests isocinétiques.c76acef6.svg";